import styled from "styled-components";
import { FlexColumn, FlexRow } from "styles/layout";
import { Theme } from "theme";

export const HeaderContainer = styled(FlexColumn)``;

export const DataLogoContainer = styled(FlexRow)``;

export const LogoContainer = styled.div`
  height: 120px;
  max-width: 110px;
  min-width: 110px;
  padding-left: ${Theme.bigPanelPaddingHorizontal};

  @media (max-width: 800px) {
    padding-left: ${Theme.smallPanelPadding};
  }

  @media (max-width: 700px) {
    max-width: 80px;
    min-width: 80px;
  }
`;

export const DataContainer = styled(FlexColumn)`
  width: 100%;
  height: 100%;
  row-gap: 12px;
  align-items: stretch;
`;

export const HeaderName = styled.div`
  font-size: 14pt;
  font-weight: 500;
  padding: 8px 20px 0 20px;

  @media (max-width: 800px) {
    padding: 8px 10px 0 10px;
  }
`;

export const HeaderDescription = styled.div`
  padding: 0 20px;

  @media (max-width: 800px) {
    padding: 0 10px;
  }
`;

export const DateLinksContainer = styled(FlexRow)`
  margin-top: auto;
  padding: 20px 10px 8px 20px;

  @media (max-width: 800px) {
    padding: 10px 8px 8px 10px;
  }
`;

export const HeaderDates = styled.div`
  padding-bottom: 8px;
`;

export const LinksContainer = styled.div`
  margin-left: auto;
  align-self: flex-end;
`;

export const TabsContainer = styled.div`
  border-top: ${Theme.panelContentBorder};
`;
